import { MouseEvent } from 'react';
import { useRouter } from 'next/router';

import Image from 'global/Image';
import useMultiPortfolioStore from 'lib/stores/multiPorto';
import CompanyIcon from 'features/multi-porto/components/CompanyLogo';
import { lotSize } from 'global/TradingModal/constant';
import { lotFormatter } from 'utils/securities/formatter';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import {
  Container,
  ContentWrapper,
  FinishButton,
  StockTransferTitle,
  StockListContainer,
  StockItem,
  StockName,
  StockLot,
} from './stock-success.styled';

const TransferStockSuccess = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const router = useRouter();

  const moveStockForm = useMultiPortfolioStore((s) => s.moveStockForm);
  const resetMoveStockForm = useMultiPortfolioStore(
    (s) => s.resetMoveStockForm,
  );

  const handleReset = () => {
    resetMoveStockForm();

    router.push('/securities/history');
  };

  const handleSubmit = () => {
    onSubmit();
    handleReset();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
    handleReset();
  };

  return (
    <BaseSecuritiesModal
      hideSubmit
      onCancel={handleCancel}
      className="modal-multi-porto"
      transitionName=""
      {...props}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <Image
          src="/images/multi-porto/success-transfer-stock.svg"
          alt=""
          height={80}
          width={80}
        />

        <ContentWrapper>
          <StockTransferTitle>Stock Transferred</StockTransferTitle>
        </ContentWrapper>

        <StockListContainer>
          {moveStockForm.stocks_data?.map((stock) => (
            <StockItem key={stock.stock_code}>
              <CompanyIcon
                symbol={stock.stock_code}
                avatar_url={stock.avatar_url}
                size={20}
              />
              <StockName>{stock.stock_code}</StockName>
              <StockLot>{lotFormatter(stock.shares / lotSize)} Lot</StockLot>
            </StockItem>
          ))}
        </StockListContainer>

        <FinishButton onClick={handleSubmit} type="primary">
          Close
        </FinishButton>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default TransferStockSuccess;
